const HomepageStoryFilter = {
    init() {
      console.log('Homepage Story Filter initialized');
     
    
      const postsContainer = document.getElementById('posts-container');
      const regionFilter = document.getElementById('region-filter');
      const loadingIndicator = document.getElementById('loading-indicator');

      const lang = document.documentElement.lang === 'fr-FR' ? 'fr' : 'en-US';

      
  
      const btnStories = document.getElementById('btn-stories');
      const btnNews = document.getElementById('btn-news');
      let storyBlock = document.querySelector('.story-block');
      let newsBlock = document.querySelector('.news-block');
  
      // Function to show the Stories block and hide the News block
      const showStories = () => {
        
          storyBlock.style.display = 'grid';
          newsBlock.style.display = 'none';
          btnStories.classList.add('active');
          btnNews.classList.remove('active');
        
      };
  
      // Function to show the News block and hide the Stories block
      const showNews = () => {
       
          storyBlock.style.display = 'none';
          newsBlock.style.display = 'grid';
          btnNews.classList.add('active');
          btnStories.classList.remove('active');
        
      };




      showStories();
  
      // Function to fetch posts
      const fetchPosts = () => {
        const region = regionFilter.value;
        loadingIndicator.style.display = 'flex';
        storyBlock.style.display = 'none';
        newsBlock.style.display = 'none';
  
        fetch(ajaxData.ajaxUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: new URLSearchParams({
            action: 'filter_posts',
            region: region,
            lang: lang,
            
          }),
          
        })
          .then((response) => response.text())
          .then((data) => {
              
            postsContainer.innerHTML = data;
            loadingIndicator.style.display = 'none';
           
            // Re-select the elements after the content is updated
            storyBlock = document.querySelector('.story-block');
            newsBlock = document.querySelector('.news-block');
            const btnStories = document.getElementById('btn-stories');
            const btnNews = document.getElementById('btn-news');

            console.log('language' + lang);

            if (btnNews.classList.contains('active')){
                showNews();
                storyBlock.style.display = 'none';
            }
            if (btnStories.classList.contains('active')){
                showStories();
                newsBlock.style.display = 'none';
            }
  
          })
          .catch((error) => {
            loadingIndicator.style.display = 'none';
            console.error('Error:', error);
          });
      };
  
      // Event listeners
      btnStories.addEventListener('click', showStories);
      btnNews.addEventListener('click', showNews);
      regionFilter.addEventListener('change', () => {
        fetchPosts(); // Assuming fetchPosts() fetches the filtered data
      });



     


      

    
    },
  };
  
  export default HomepageStoryFilter;




// WEBPACK FOOTER //
// ./src/js/jquery/homepage-story-filter.js